const isMaximum = (value, number) =>
  value && value.length > number && `Este valor deve ter no máximo ${number} caracteres!`;

export default isMaximum;
